import React from "react";
import { HeaderGroup, flexRender } from "@tanstack/react-table";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { getAlignClass, BaseColumnDef, TableColumnAlign } from "./types";

interface DataTableHeaderProps<T> {
  headerGroups: HeaderGroup<T>[];
  styles?: {
    headerBg?: string;
    headerText?: string;
  };
}

export function DataTableHeader<T>({
  headerGroups,
  styles,
}: DataTableHeaderProps<T>) {
  return (
    <thead
      className={`${styles?.headerBg || "bg-gray-100"} border-b-2 border-gray-200 sticky top-0 z-10`}
    >
      {headerGroups.map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => {
            const columnDef = header.column.columnDef as BaseColumnDef<T>;
            const canSort = header.column.getCanSort();
            const sortDirection = header.column.getIsSorted();

            return (
              <th
                key={header.id}
                className={`
                  ${columnDef.headerClassName || ""}
                  ${getAlignClass(columnDef.align)}
                  px-6 py-4
                  text-xs font-semibold
                  ${styles?.headerText || "text-gray-700"}
                  uppercase tracking-wider
                  ${canSort ? "cursor-pointer select-none hover:bg-gray-200" : ""}
                  transition-colors duration-150
                `}
                style={{
                  width: header.getSize() !== 150 ? header.getSize() : undefined,
                }}
                onClick={
                  canSort
                    ? header.column.getToggleSortingHandler()
                    : undefined
                }
              >
                <div className="flex items-center gap-2">
                  {header.isPlaceholder
                    ? null
                    : flexRender(header.column.columnDef.header, header.getContext())}
                  {canSort && (
                    <span className="inline-flex items-center">
                      {sortDirection === "asc" ? (
                        <ArrowUp className="h-3 w-3" />
                      ) : sortDirection === "desc" ? (
                        <ArrowDown className="h-3 w-3" />
                      ) : (
                        <ArrowUpDown className="h-3 w-3 opacity-50" />
                      )}
                    </span>
                  )}
                </div>
              </th>
            );
          })}
        </tr>
      ))}
    </thead>
  );
}

